import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import styles from "styles/modules/importClaims.module.scss";
import SimpleSlider from "components/SimpleSlider";
import LeftRightScrollButtonSmall from "components/LeftRightScrollButtonSmall";


const ReusableTextSummaryBox = ({ reusableText }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [inputValue, setInputValue] = useState("1"); // Changed from "01" to "1"
  const sliderRef = useRef();

  // Prepare the slides data
  const allTexts = [
    { id: "main", matchText: reusableText?.matchText || "No text available" },
    ...(reusableText?.matchTextVariants || []),
  ];

  const slides = allTexts.map((text) => (
    <div key={text.id} className={styles.slideContent}>
      <div className={styles.textWrapper}>{text.matchText}</div>
    </div>
  ));

  const goToSlide = (slideIndex) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(slideIndex);
    }
  };

  useEffect(() => {
    goToSlide(currentSlideIndex);
    setInputValue(String(currentSlideIndex + 1)); // Removed formatNumber
  }, [currentSlideIndex]);

  const handlePagination = (direction) => {
    setCurrentSlideIndex((prevState) => {
      if (direction === "forward" && prevState < allTexts.length - 1) {
        return prevState + 1;
      } else if (direction === "backward" && prevState > 0) {
        return prevState - 1;
      }
      return prevState;
    });
  };

  return (
    <div className={styles.reuseelementxBox}>
      <div className={styles.titleContainer}>
        <div className={`${styles.title}`}>
          <span>Match Text</span>
        </div>
      </div>

      <div className={styles.reusedescriptionbox}>
        <SimpleSlider
          sliderRef={sliderRef}
          currentSlide={currentSlideIndex}
          onSlideChange={setCurrentSlideIndex}
        >
          {slides}
        </SimpleSlider>
      </div>
      <hr className={styles.horizdivider} />
      <div className={styles.paginationControls}>
        <LeftRightScrollButtonSmall
          handleClick={handlePagination}
          disabled={false}
          shouldRightDisabled={currentSlideIndex === allTexts.length - 1}
          shouldLeftDisabled={currentSlideIndex === 0}
          count={String(allTexts.length)} 
          currentValue={inputValue}
        />
      </div>
    </div>
  );
};

export default ReusableTextSummaryBox;
